import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";

const SosHomeActionItems = {
    items: [
        {
            title: "Novo Cadastro",
            subTitle: "Adicionar protegido",
            icon: "img/sos/home/add.svg",
            permission: PermissionEnum.SOS_MANAGE_CITIZEN,
            devUrl: "/sos/citizens/form",
            url: "/citizens/create"
        },
        {
            title: "Protegidos",
            subTitle: "Lista de protegidos",
            icon: "img/sos/home/citizens.svg",
            permission: [PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_VIEW],
            devUrl: "/sos/citizens",
            url: "/citizenVerified"
        },
        {
            title: "Agressores",
            subTitle: "Lista de agressores",
            icon: "img/sos/home/aggressors.svg",
            permission: [PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_VIEW],
            devUrl: "/sos/aggressors-list",
            url: "/sos/aggressors-list"
        },
        {
            title: "Programas de Proteção ",
            subTitle: "Cadastro de programas",
            icon: "img/sos/home/protect-programs.svg",
            permission: PermissionEnum.SOS_PROTECTION_PROGRAM,
            devUrl: "/sos/protection-program",
            url: "/sosProtectionProgram"
        },
        {
            title: "Histórico SOS ",
            subTitle: "Lista de acionamentos",
            icon: "img/sos/home/sos-history.svg",
            permission: PermissionEnum.SOS_MANAGE_EVENTS,
            devUrl: "/sos/event-history",
            url: "/sosFinalized"
        },
        {
            title: "Agendamento",
            subTitle: "Planejamento de atividades",
            icon: "img/sos/home/schedule.svg",
            permission: PermissionEnum.SOS_CITIZEN_SCHEDULED_VISIT_MANAGE,
            devUrl: "/sos/citizen-scheduled-visit",
            url: "/sos/citizen-scheduled-visit"
        },
        {
            title: "Dashboards",
            subTitle: "Métricas em tempo real",
            icon: "img/sos/home/dashboard.svg",
            permission: PermissionEnum.SOS_DASHBOARD,
            devUrl: "/sos/dashboard-sos",
            url: "/sos/dashboard-sos"
        },
        {
            title: "Relatório",
            subTitle: "Raio X de SOS",
            icon: "img/sos/home/xray.svg",
            permission: PermissionEnum.REPORT_SOS_XRAY,
            devUrl: "/reports/sos_x_ray",
            url: "/reports/sos_x_ray"
        },
        {
            title: "Relatório",
            subTitle: "Lista de protegidos",
            icon: "img/sos/home/citizens-list.svg",
            permission: PermissionEnum.REPORT_SOS_RECORDS,
            devUrl: "/reports/sos_records",
            url: "/reports/sos_records"
        },
    ],

    optionsToUser: (hasPermission) => {
        return SosHomeActionItems.items.filter(item => {
            if (!item?.permission) return true;

            const permissions = Array.isArray(item.permission) ? item.permission : [item.permission];

            return permissions.some(permission => hasPermission(permission));
        });
    }
}

export default SosHomeActionItems;